import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4fb2944"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "wrapper-div",
  id: "highest-emission-results-wrapper-div"
}
const _hoisted_2 = {
  id: "section-one-container",
  class: "section-container"
}
const _hoisted_3 = { id: "section-one-main-header" }
const _hoisted_4 = {
  id: "main-description-text",
  class: "main-description-text"
}
const _hoisted_5 = {
  id: "section-two-container",
  class: "section-container"
}
const _hoisted_6 = {
  class: "form-group",
  "aria-labelledby": "multiselect-scopes-label"
}
const _hoisted_7 = {
  id: "multiselect-scopes-label",
  class: "form-label"
}
const _hoisted_8 = { class: "multiselect-wrapper col-3 p-0 m-0" }
const _hoisted_9 = { class: "padding-10-bottom-top" }
const _hoisted_10 = { class: "align-self-center" }
const _hoisted_11 = { id: "section-two-figure-description-header" }
const _hoisted_12 = {
  id: "section-two-figure-description-main-text",
  class: "main-description-text"
}
const _hoisted_13 = {
  id: "section-tree-container",
  class: "section-container"
}
const _hoisted_14 = {
  key: 0,
  id: "highest-emission-result-table",
  class: "table results-table w-percent-100",
  "aria-describedby": "highest-emission-result-table-header1",
  "aria-label": "OVERSIGT OVER CO2-E UDLEDNINGEN I TON CO2-E FORDELT PÅ UNDERKATEGORIER"
}
const _hoisted_15 = { class: "bg-primary text-color-white" }
const _hoisted_16 = {
  id: "highest-emission-result-table-header1",
  colspan: "4",
  scope: "colgroup"
}
const _hoisted_17 = {
  style: {"font-weight":"600"},
  class: "w-percent-100"
}
const _hoisted_18 = {
  style: {"width":"30%"},
  class: "py-405 align-text-left bg-primary text-color-white",
  id: "results.highest-emission.table-subheader-one",
  headers: "highest-emission-result-table-header1"
}
const _hoisted_19 = {
  style: {"width":"40%"},
  class: "py-405 align-text-left bg-primary text-color-white",
  id: "results.highest-emission.table-subheader-two",
  headers: "highest-emission-result-table-header1"
}
const _hoisted_20 = {
  style: {"width":"15%"},
  class: "py-405 align-text-left bg-primary text-color-white",
  id: "results.highest-emission.table-subheader-three",
  headers: "highest-emission-result-table-header1"
}
const _hoisted_21 = {
  style: {"width":"15%"},
  class: "py-405 align-text-left bg-primary text-color-white",
  id: "results.highest-emission.table-subheader-four",
  headers: "highest-emission-result-table-header1"
}
const _hoisted_22 = { headers: "results.highest-emission.table-subheader-one" }
const _hoisted_23 = { headers: "results.highest-emission.table-subheader-two" }
const _hoisted_24 = {
  headers: "results.highest-emission.table-subheader-three",
  class: "align-text-right"
}
const _hoisted_25 = {
  headers: "results.highest-emission.table-subheader-four",
  class: "align-text-right"
}
const _hoisted_26 = {
  id: "highest-emission-result-table-totals",
  class: "align-text-right bg-primary text-color-white",
  style: {"font-weight":"600"}
}
const _hoisted_27 = { colspan: "2" }
const _hoisted_28 = { class: "small-text" }
const _hoisted_29 = {
  class: "align-text-right",
  headers: "results.highest-emission.table-subheader-three"
}
const _hoisted_30 = {
  class: "italic-text align-text-right",
  headers: "results.highest-emission.table-subheader-four"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_HighestEmissionResultsColumnChart = _resolveComponent("HighestEmissionResultsColumnChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createVNode(_component_SimpleText, { "text-key": "results.highest-emissions.main-header" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RichText, { "text-key": "results.highest-emissions.main-description-text" })
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createVNode(_component_SimpleText, { "text-key": "forecast.result.scope123.field.forecast-scope.name" })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.selectedScopes,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedScopes) = $event)),
              mode: "tags",
              "close-on-select": false,
              hideSelected: false,
              canClear: false,
              groups: false,
              options: _ctx.possibleScopes,
              valueProp: "scopeId",
              label: "scopePresentationName",
              aria: {'aria-labelledby':'multiselect-scopes-label', 'aria-placeholder': null, 'aria-multiselectable': null},
              ref: "input-highest-emissions-scope",
              class: "multiselect-calculation form-group",
              placeholder: _ctx.getContentfulString('forecast.resultview.filter.placeholder.allscopesselected')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            id: "submit-button-highest-emissions",
            class: "button button-primary",
            type: "submit",
            role: "button",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.renderChart()), ["prevent"])),
            onKeydown: [
              _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.renderChart()), ["enter"])),
              _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.renderChart()), ["prevent"]), ["space"]))
            ],
            onKeyDown: "renderChart()"
          }, [
            _createVNode(_component_SimpleText, { "text-key": 'results.highest-emissions.submit-button-text' }, null, 8, ["text-key"])
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.graphDescription), 1),
        _createElementVNode("p", _hoisted_12, _toDisplayString(this.dynamicContentfulText('results.highest-emission.figure-description-main-text', '#TotalCo2Emission#', String(_ctx.doPrettify(this.currentScopesTotal)))), 1)
      ]),
      (_ctx.tableTopTwenty)
        ? (_openBlock(), _createBlock(_component_HighestEmissionResultsColumnChart, {
            key: 0,
            id: "highest-emission-result-column-chart",
            ref: "highestEmissionResultsColumnChart",
            "raw-data": _ctx.tableTopTwenty,
            electricityEnvironmentDeclaration: _ctx.results.electricityEnvironmentDeclaration,
            filter: _ctx.chartSettings
          }, null, 8, ["raw-data", "electricityEnvironmentDeclaration", "filter"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_ctx.results?.groupingResults)
        ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_15, [
                _createElementVNode("th", _hoisted_16, [
                  _createVNode(_component_SimpleText, { "text-key": "results.highest-emission.table-header-one" })
                ])
              ])
            ]),
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_17, [
                _createElementVNode("th", _hoisted_18, [
                  _createVNode(_component_SimpleText, { "text-key": "results.highest-emission.table-subheader-one" })
                ]),
                _createElementVNode("th", _hoisted_19, [
                  _createVNode(_component_SimpleText, { "text-key": "results.highest-emission.table-subheader-two" })
                ]),
                _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.tableHeaderTotalDescription), 1),
                _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.tableHeaderTotalPercentageDescription), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableTopTwenty.sort((a,b)=>(b.scopeTotal - a.scopeTotal)), (line) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: line.calculationLineId
                }, [
                  _createElementVNode("td", _hoisted_22, _toDisplayString(line.calculationLineDescription), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(line.position), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.doPrettify(line.scopeTotal)), 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.doPrettify(line.scopePercentage)) + "%", 1)
                ]))
              }), 128)),
              _createElementVNode("tr", _hoisted_26, [
                _createElementVNode("td", _hoisted_27, [
                  _createVNode(_component_SimpleText, { "text-key": "sharedContent.total" }),
                  _createTextVNode(),
                  _createElementVNode("span", _hoisted_28, "(" + _toDisplayString(this.electricityCalculationMethodText(_ctx.results.electricityEnvironmentDeclaration)) + ")", 1)
                ]),
                _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.doPrettify(this.currentScopesTotal)), 1),
                _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.doPrettify(this.tableHeaderTotalPercentage)) + "% ", 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}